import { render, staticRenderFns } from "./TherapyLandingPage.vue?vue&type=template&id=dbbcf468"
import script from "./TherapyLandingPage.vue?vue&type=script&lang=js"
export * from "./TherapyLandingPage.vue?vue&type=script&lang=js"
import style0 from "./TherapyLandingPage.vue?vue&type=style&index=0&id=dbbcf468&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports